<template>
  <div class="multipicker">
    <div v-for="(group, index) in list || []" :key="index">
      <div class="group" v-for="(item, j) in group.children || []" :key="j">
        <div class="label">{{ group.group }}</div>
        <div class="item" :class="item.value == selected && 'active'"
          @click="onSelect(item)">
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="empty" v-if="!list || !list.length">
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  name: 'pickerComp',
  props: {
    list: {
      type: Array,
      default: null
    },
    selected: {
      type: [ Number, String ],
      default: null
    }
  },

  methods: {
    onSelect(item) {
      this.$emit('change', item);
    }
  }
}
</script>

<style lang="scss">
.multipicker{
  max-height: 30vh;
  overflow-y: auto;
  width: max-content;
  padding: 3px;
  padding-right: 0;
  .group{
    border-bottom: 1px solid #eee;
    .label{
      color: #999999;
    }

    &:last-child{
      border-bottom: none;
    }
  }
  .item{
    margin: 3px 0;
    padding: 6px 12px;
    min-width: 12em;
    border-radius: 6px;
    transition: 300ms;

    &:hover{
      background-color: #f4f4f4;
    }
    &.active{
      background-color: #25a3ff20;
      color: var(--main-color);
    }
  }

  &::-webkit-scrollbar{
    width: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: #ddd;
    border-radius: 5px;
    transition: 300ms;
    &:hover{
      background-color: #ccc;
    }
  }
}
</style>